var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8946 6.52212C20.5318 4.68396 19.5422 3.02875 18.0946 1.8392C16.6471 0.649656 14.8315 -0.000423552 12.9579 2.07042e-07C9.83718 2.07042e-07 7.12682 1.77091 5.77705 4.36248C4.18996 4.53399 2.72224 5.28595 1.65589 6.47388C0.589552 7.66181 -0.000185407 9.20189 4.3725e-08 10.7982C4.3725e-08 14.3724 2.90472 17.2772 6.47893 17.2772H20.5166C23.4969 17.2772 25.9157 14.8583 25.9157 11.878C25.9157 9.02731 23.7021 6.71649 20.8946 6.52212ZM18.357 9.7184L13.3358 14.7396C13.1198 14.9555 12.7851 14.9555 12.5691 14.7396L7.55875 9.7184H10.7982V5.39911H15.1175V9.7184H18.357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadMaster);
export default __webpack_public_path__ + "static/media/download-master.43aec62556529bc40115e30c88560f53.svg";
export { ForwardRef as ReactComponent };